export default __webpack_public_path__ + "static/char-s-58-zh-Hant-07b029c7ffc88768ee75c154b7e84a1e.png";